(function(){
  if (window.__ostClip) return;
  window.__ostClip = true;

  /* ---------- video wall ---------- */

  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('[data-ost-play]') : null;
    if (!btn) return;
    var item = btn.closest('[data-ost-clip]');
    var v = item && item.querySelector('video');
    if (!v) return;
    item.classList.add('is-playing');
    v.setAttribute('controls', '');
    var p = v.play();
    if (p && p.catch) p.catch(function(){ item.classList.remove('is-playing'); });
  });

  document.addEventListener('play', function(e){
    var t = e.target;
    if (!t || t.tagName !== 'VIDEO') return;
    document.querySelectorAll('[data-ost-clip] video').forEach(function(o){
      if (o !== t && !o.paused) o.pause();
    });
  }, true);

  /* ---------- pinned advisory bar ----------
     position:sticky is useless here: the bar lives inside a section wrapper
     only as tall as the bar, so it has nothing to stick within. Pin it with
     position:fixed, leave a spacer of equal height so the page doesn't jump,
     and push the theme's sticky header down by the same amount. Measured, so
     it survives copy changes and wrapping on small screens. */

  var SPACER_ID = 'ost-adv-spacer';

  function pinAdvisory(){
    var adv = document.querySelector('.ost-advisory');
    if (!adv) return;

    if (adv.style.position === 'fixed') adv.style.position = '';
    var h = Math.round(adv.getBoundingClientRect().height);
    if (!h) return;

    adv.style.position = 'fixed';
    adv.style.top = '0';
    adv.style.left = '0';
    adv.style.right = '0';
    adv.style.zIndex = '80';

    var spacer = document.getElementById(SPACER_ID);
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.id = SPACER_ID;
      spacer.setAttribute('aria-hidden', 'true');
      if (adv.parentNode) adv.parentNode.insertBefore(spacer, adv.nextSibling);
    }
    spacer.style.height = h + 'px';
    document.documentElement.style.setProperty('--ost-adv-h', h + 'px');

    var sel = 'header, header-component, .header-wrapper, [id^="shopify-section"][class*="header"]';
    document.querySelectorAll(sel).forEach(function(el){
      if (el === adv || el.contains(adv) || adv.contains(el)) return;
      var cs = window.getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') el.style.top = h + 'px';
    });
  }

  /* ---------- sticky add-to-cart bar ----------
     Driven by scroll depth, not by watching the main button. The buy column is
     position:sticky, so on desktop that button never leaves the viewport and an
     IntersectionObserver on it would never fire. */

  function stickyAtc(){
    var bar = document.querySelector('[data-ost-sticky]');
    if (!bar || bar.__ostBound) return;
    bar.__ostBound = true;

    var threshold = Math.max(300, Math.round(window.innerHeight * 0.55));
    var ticking = false;

    function apply(){
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      bar.classList.toggle('is-on', y > threshold);
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function(){
      threshold = Math.max(300, Math.round(window.innerHeight * 0.55));
      apply();
    });
    apply();
  }

  function boot(){
    pinAdvisory();
    stickyAtc();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pinAdvisory);
    setTimeout(pinAdvisory, 400);
  }

  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t); t = setTimeout(pinAdvisory, 150);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
